export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: 'Dr.COM Billingware',

  /**
   * @description 配置显示在浏览器标签的title
   */
  baseUrl: {
    dev: '',
    pro: ''
  },

}
